import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33334 3.66663C5.30829 3.66663 3.66667 5.30825 3.66667 7.33329C3.66667 9.35835 5.30829 11 7.33334 11C9.3584 11 11 9.35835 11 7.33329C11 5.30825 9.3584 3.66663 7.33334 3.66663ZM2.66667 7.33329C2.66667 4.75596 4.75601 2.66663 7.33334 2.66663C9.91068 2.66663 12 4.75596 12 7.33329C12 8.44185 11.6135 9.46012 10.9678 10.2607L13.1869 12.4797C13.3822 12.675 13.3822 12.9916 13.1869 13.1868C12.9916 13.3821 12.675 13.3821 12.4798 13.1868L10.2607 10.9678C9.46017 11.6134 8.4419 12 7.33334 12C4.75601 12 2.66667 9.91064 2.66667 7.33329Z"
      fill="currentColor"
    />
  </SvgIcon>
));
